import { AlpineComponent } from 'alpinejs';

const ReadingProgress = (): AlpineComponent => ({
  progress: 0,
  updateProgress() {
    const footer = document.querySelector('footer');
    const footerHeight = footer?.offsetHeight || 0;

    const currentProgress = window.scrollY;
    const scrollHeight =
      document.body.scrollHeight - window.innerHeight - footerHeight;
    this.progress = Number(currentProgress / scrollHeight);

    if (this.progress >= 1) {
      this.$root.setAttribute('hidden', true);
    } else {
      this.$root.removeAttribute('hidden');
    }
  },
  init() {
    window.addEventListener('scroll', () => {
      let timeout = null;
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      timeout = window.requestAnimationFrame(() => {
        this.updateProgress();
      });
    });
  }
});

export default ReadingProgress;
